export const account_types: Array<IOption> = [
  {value: 'complementary_industries', label: 'صنایع تکمیلی '},
  {value: 'wholesaler', label: 'خریدار و فروشنده عمده'},
  {value: 'merchant', label: 'بازرگان'},
  {value: 'fridge', label: 'سردخانه'},
];
